import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.tailwind.css'
import { initializeTheme } from './utils/theme'

initializeTheme()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
